const initialState: any = {
  visible: false
};

export default initialState;
